// src/components/routes/TicketViewWrapper.jsx
// Wrapper que determina qué componente de ticket usar según la marca
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../helpers/apiHelper';
import TicketView from '../../pages/cliente/TicketView';
import TicketViewCustom from '../../templates/empanadaclub/TicketView';

const CUSTOM_TEMPLATE_MARCA_ID = '68fa4bcb635d5ec4280f8a89';

const TicketViewWrapper = () => {
    const { ticketUrl } = useParams();
    const [ticket, setTicket] = useState(null);
    const [loading, setLoading] = useState(true);
    const [useCustomTemplate, setUseCustomTemplate] = useState(false);

    useEffect(() => {
        const fetchTicketAndCheckTemplate = async () => {
            try {
                if (!ticketUrl) {
                    setLoading(false);
                    return;
                }

                // Obtener el ticket
                const response = await get(`tickets/url/${ticketUrl}`);
                setTicket(response);

                // Verificar si la marca del ticket es la marca personalizada
                if (response?.marca?._id === CUSTOM_TEMPLATE_MARCA_ID) {
                    setUseCustomTemplate(true);
                }
            } catch (error) {
                console.error('Error fetching ticket:', error);
                // Si hay error, usar el componente por defecto
                setUseCustomTemplate(false);
            } finally {
                setLoading(false);
            }
        };

        fetchTicketAndCheckTemplate();
    }, [ticketUrl]);

    // Mientras carga, mostrar el componente por defecto (que tiene su propio loading)
    if (loading) {
        return <TicketView />;
    }

    // Si el ticket es de la marca personalizada, usar el componente personalizado
    if (useCustomTemplate && ticket) {
        return <TicketViewCustom />;
    }

    // En cualquier otro caso, usar el componente por defecto
    return <TicketView />;
};

export default TicketViewWrapper;

